import React from 'react';
import { BellRinging } from '@phosphor-icons/react';

import { Button } from '../../../components/general';

import { isEmpty } from '../../../utils';

import AttendeePanel from './attendeePanel';
import { ExtendedEvent } from './getData';

interface Props {
  event: ExtendedEvent;
}

const NotePanel: React.FC<Props> = (props) => {
  const { event } = props;

  const isUploadUGC = event.stage === 'Analysis' && isEmpty(event.clips);

  return (
    <AttendeePanel
      heading={isUploadUGC ? 'Your Help Required' : 'Wait For It'}
      className="w-[30%] items-center text-center"
    >
      {isUploadUGC ? (
        <React.Fragment>
          <div>
            Looks like there <b>wasn’t quite enough footage of you</b> captured
            during the event.
          </div>

          <div>
            If you took any selfie videos at the event or have any footage on
            your phone you’d like to include, upload them below and generate
            your personalised video in just few clicks.
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div>
            Your Highlight Reel isn’t ready just yet – but we’re working on it!
          </div>

          <div>Be notified the moment your video is available.</div>

          <Button
            colour="black-outline"
            className="w-full font-semibold"
            withGap
          >
            <BellRinging size="1.25rem" />
            <div>Notify Me</div>
          </Button>
        </React.Fragment>
      )}
    </AttendeePanel>
  );
};

export default NotePanel;
